import { render, staticRenderFns } from "./add_dialog.vue?vue&type=template&id=6e024564&scoped=true"
import script from "./add_dialog.vue?vue&type=script&lang=js"
export * from "./add_dialog.vue?vue&type=script&lang=js"
import style0 from "./add_dialog.vue?vue&type=style&index=0&id=6e024564&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e024564",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e024564')) {
      api.createRecord('6e024564', component.options)
    } else {
      api.reload('6e024564', component.options)
    }
    module.hot.accept("./add_dialog.vue?vue&type=template&id=6e024564&scoped=true", function () {
      api.rerender('6e024564', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/sign_group/form/components/add_dialog.vue"
export default component.exports